import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p383653214795382784',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
